import styled, { css } from 'styled-components';
import svgSelect from '../../../static/img/select.svg';

interface Props {
  errorMessage?: string;
  disabled?: boolean;
}

export const SelectStyled = styled.select<Props>`
  height: 40px;
  width: 366px;
  border: 1px solid #666666;
  border-radius: 8px;
  padding: 10px;
  margin-top: 8px;
  -webkit-appearance: none;
  background-color: ${props => (!props.disabled ? '#FFFFFF' : '#d8d8d8')};
  color: #000000;
  font-size: 14px;
  font-family: 'inter';
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${props => (!props.disabled ? '#FFFFFF' : '#d8d8d8')};
    font-size: 14px;
    font-family: 'Inter';
  }
  &:disabled {
    opacity: 1;
  }
  background-image: url('${svgSelect}');
  background-repeat: no-repeat;
  background-position: 97%;
  ${props =>
    props.errorMessage &&
    css`
      border-image: none;
      border: 1px solid red;
    `}

  &:focus,&:hover {
    outline: none;
    border: ${props =>
      !props.errorMessage ? '1px solid #0669de' : '1px solid red'};
  }
  @media (max-width: 650px) {
    width: 100%;
  }

  /* FIX: autofill do Chrome */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-internal-autofill-selected,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 50px
      ${props => (!props.disabled ? '#FFFFFF' : '#d8d8d8')} inset !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: 5px !important;
  color: red;
`;
